
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const weightGainReason = useStore((state) => state.weightGainReason);
  const setWeightGainReason = useStore((state) => state.setWeightGainReason);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.weightGainReason.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={weightGainReason}
          onChange={(value) => {
            setWeightGainReason(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'weight-gain-reason',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Injury or physical health issues"}>
            <span>🤕</span> {t('onboarding.weightGainReason.options.injury')}
          </Option>
          <Option value={"Work or personal life"}>
            <span>💼</span> {t('onboarding.weightGainReason.options.personalLife')}
          </Option>
          <Option value={'Slower metabolism'}>
            <span>🐢</span> {t('onboarding.weightGainReason.options.slowerMetabolism')}
          </Option>
           <Option value={'Stress or mental health struggles'}>
            <span>😔</span> {t('onboarding.weightGainReason.options.stress')}
          </Option>
           <Option value={'Medication'}>
            <span>💊</span> {t('onboarding.weightGainReason.options.medication')}
          </Option>
          <Option value={'Other'}>
            <span>🔹</span> {t('onboarding.weightGainReason.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
